'use strict';
let React = require('react');
let ReactRedux = require('react-redux');

let HeaderLayoutComponent = require('../../../views/layouts/header').HeaderLayoutComponent;
var FooterLayout = require('../../../views/layouts/footer').FooterLayoutComponent;
let SidebarLayoutComponent = require('../../../views/layouts/sidebar').SidebarLayoutComponent;
let BaseComponent = require('../../shared/base');
let toastr = require('toastr');
let TableContentComponent = require('../../features/checkout_flow_type/' + process.env.CHECKOUT_FLOW_TYPE + '/purchase_order/detail/table.jsx');
let TransactionSummaryComponent = require('../../features/checkout_flow_type/' + process.env.CHECKOUT_FLOW_TYPE + '/purchase_order/detail/transaction_summary.jsx');
let OrderDiaryComponent = require('../../features/checkout_flow_type/' + process.env.CHECKOUT_FLOW_TYPE + '/purchase_order/order-diary');
let ShippingPaymentDetailComponent = require('../../features/checkout_flow_type/' + process.env.CHECKOUT_FLOW_TYPE + '/purchase_order/detail/shipping_payment_detail');
import { SEK } from 'currency-symbol-map/map';
import { submitFeedbackForCartItem } from '../../../redux/purchaseActions';

// Order Diary
var OrderDiaryActions = require('../../../redux/orderDiaryActions');

let TableInvoicesComponent = require('../../custom/orders/tableinvoices');
let SummaryOrder = require('../../custom-views/order-detail/summary-order'); 
let client = require('../../../../sdk/client');
let OrderItemsTableComponent = require('../../custom/orders/order-items-table');

class PurchaseDetailComponent extends BaseComponent {

    constructor(props){
        super(props)
        this.state = {
            data: {},
            datamodalSupplyOrder: [],
            datamodalShippingGuides: [],
            arrOrderData: [],
            customerRFC: ""
        }

        this.updateDataModalSupplyOrders = this.updateDataModalSupplyOrders.bind(this);
        this.updateDataModalShippingGuides = this.updateDataModalShippingGuides.bind(this);
        
    }

    componentDidMount() {
        const target = $(".popup-area.order-item-feedback-popup");
        const cover = $("#cover");
        const self = this;
        $('.btn-feedback').click(function (e) {
            const hasFeedback = $(this).attr('has-feedback');
            if (hasFeedback == '0') {

                target.fadeIn();
                cover.fadeIn();

                $('body').addClass('modal-open');
                const itemUrl = $(this).attr('item-url');
                const itemImgUrl = $(this).attr('item-image-url');
                const itemName = $(this).attr('item-name');
                const cartItemID = $(this).attr('cart-item-id');
                self.setState({ selectedCartItemID: cartItemID });
                $('.ordr-dtls-item-iteminfo .item-img a').attr('href', itemUrl)
                $('.ordr-dtls-item-iteminfo .item-img a img').attr('src', itemImgUrl);
                $('.ordr-dtls-item-iteminfo .item-info-text div a').attr('href', itemUrl);
                $('.ordr-dtls-item-iteminfo .item-info-text div a').text(itemName);
            } else {
                toastr.warning('You already posted a review.', 'Failed in Posting Review')
            }
        });

        $('#stars').on('starrr:change', function (e, value) {
            $('input[name=rating_val]').val(value);
        });

        $('.close-popup-icon').click(function (e) {
            target.hide();
            cover.hide();
            $('#stars .glyphicon').removeClass('glyphicon-star');
            $('#stars .glyphicon').addClass('glyphicon-star-empty');
            $('input[name=rating_val]').val();
            $('.content-area .quote').remove();
            $('textarea[name=feedbackText]').val('');
            $('body').removeClass('modal-open');
            self.setState({ selectedCartItemID: null });
        });

        $('body').on('mouseout', '#stars .glyphicon', function () {
            var $this = $(this);
            var rating = parseInt($this.parent('.starrr').find('.glyphicon-star').length);
            if (!rating)
                $this.parent('.starrr').next('.quote').remove();

            if ($('input[name=rating_val]').val())
                $this.parent('.starrr').next('.quote').text(self.getQuote(rating));

        });

        $('body').on('mouseenter', '#stars .glyphicon', function () {
            var $this = $(this);
            var rating = parseInt($this.parent('.starrr').find('.glyphicon-star').length);
            var quote = self.getQuote(rating)
            var ob_quote = '<span class="quote">' + quote + '</span>';
            $this.parent('.starrr').next('.quote').remove();
            $this.parent('.starrr').after(ob_quote);
        });

        $('.my-btn').click(function (e) {
            const rating = $('input[name=rating_val]').val();
            const feedback = $('textarea[name=feedbackText]').val();
            if (rating === null || typeof rating === 'undefined' || rating == '') {
                toastr.warning('You forgot to select your star rating.', 'Oops! Something went wrong.');
            } else {
                self.submitFeedback(rating, feedback);
                target.hide();
                cover.hide();
                $('#stars .glyphicon').removeClass('glyphicon-star');
                $('#stars .glyphicon').addClass('glyphicon-star-empty');
                $('input[name=rating_val]').val();
                $('.content-area .quote').remove();
                $('textarea[name=feedbackText]').val('');
                $('body').removeClass('modal-open');
                self.setState({ selectedCartItemID: null });
            }
        });

        this.loadUserCustomFields();
    }

    loadUserCustomFields() {
        let self = this;
        client.Users.getUserDetails({
            excludeToken: false,
            userId: this.props.user.ID,
            includeUserCustomFields: true
        }, function (err, user) {
            let customerRFC = user.CustomFields.find(x => x.Code == process.env.CF_RFC_EMPRESA).Values[0];
            if(customerRFC != undefined){
                self.setState({customerRFC:customerRFC});
            }
            else{
                toastr.error("Error al cargar detalles de la orden, no se tiene definido el RFC");
            }
        });
    }

    getAllEvents() {
        return (this.props.events || []).concat((this.props.otherEvents || []));
    }

    getQuote(rating) {
        var quote = '';
        //switch (rating) {
        //    case 1:
        //        quote = 'Unsatisfied.';
        //        break;
        //    case 2:
        //        quote = 'Okay.';
        //        break;
        //    case 3:
        //        quote = 'Good.';
        //        break;
        //    case 4:
        //        quote = 'Great!';
        //        break;
        //    case 5:
        //        quote = 'Excellent!!';
        //        break;
        //}
        return quote;
    }

    renderSupplierAddress() {
        let shippingAddress = null;
        let supplierDisplayName = null;
        let detail = process.env.CHECKOUT_FLOW_TYPE === 'b2b' ? this.props.detail : this.props.detail.Orders[0]

        if (detail) {
            shippingAddress = detail.DeliveryFromAddress;
            supplierDisplayName = detail.MerchantDetail ? detail.MerchantDetail.DisplayName : '';
        }

        if (typeof shippingAddress != 'undefined' && shippingAddress && shippingAddress.Name) {

            const supplierName = typeof shippingAddress != 'undefined' && shippingAddress && shippingAddress.Name && shippingAddress.Name.split('|').length > 1 ? shippingAddress.Name.replace('|', ' ') : shippingAddress.Name;
            const line2 = typeof shippingAddress != 'undefined' && shippingAddress && shippingAddress.Line2 ? shippingAddress.Line2 : "";

            return (
                <div className="col-md-4">
                    <table className="canon-table purchase-address-sec">
                        <tbody><tr>
                            <th>Supplier :</th>
                        </tr>
                            <tr>
                                <td data-th="Supplier :">
                                    <span className="highlight-text">{supplierDisplayName}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span className="highlight-text">{supplierName}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {shippingAddress.Line1},<br />
                                    {line2 &&
                                        <React.Fragment>
                                            {line2} <br />
                                        </React.Fragment>
                                    }
                                    {shippingAddress.City &&
                                        <React.Fragment>
                                            {shippingAddress.City} <br />
                                        </React.Fragment>
                                    }
                                    {shippingAddress.State &&
                                        <React.Fragment>
                                            {shippingAddress.State} <br />
                                        </React.Fragment>
                                    }
                                    {shippingAddress.Country}<br />
                                    {shippingAddress.PostCode}<br />
                                </td>
                            </tr>
                            {this.renderSupplierEmailContact()}
                        </tbody>
                    </table>
                </div>
            );
        } else {
            return "";
        }

    }

    renderSupplierEmailContact() {
        let detail = process.env.CHECKOUT_FLOW_TYPE === 'b2b' ? this.props.detail : this.props.detail.Orders[0]
        let contactNo = '';
        let email = '';
        if (detail) {
             contactNo = detail.MerchantDetail.PhoneNumber;
             email = detail.MerchantDetail.Email;
        }
       
        if (process.env.PRICING_TYPE === "service_level") {
            return (
                <React.Fragment>
                    <tr>
                        <td data-th="Supplier :">{ contactNo }</td>
                    </tr>
                    <tr>
                        <td data-th="Supplier :">{ email }</td>
                    </tr>
                </React.Fragment>
            );
        }
        return null;
    }

    renderShippingAddress() {
        let shippingAddress = null;
        if (this.props.detail.Orders) {
            shippingAddress = this.props.detail.Orders[0].DeliveryToAddress;
        } else {
            shippingAddress = this.props.detail.DeliveryToAddress;
        }

        const buyerName = shippingAddress.Name && shippingAddress.Name.split('|').length > 1 ? shippingAddress.Name.replace('|', ' ') : shippingAddress.Name;
        const line2 = shippingAddress.Line2 ? shippingAddress.Line2 : "";
        if (shippingAddress && shippingAddress.Name) {
            return (
                <div className="col-md-4">
                    <table className="canon-table purchase-address-sec">
                        <tbody><tr>
                            <th className="OD-tittle-subsection">Dirección de envío:</th>
                        </tr>
                            <tr>
                                <td data-th="Shipping Address :">
                                    <span className="highlight-text">{buyerName}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {shippingAddress.Line1},<br />
                                    {line2 &&
                                        <React.Fragment>
                                            {line2} <br />
                                        </React.Fragment>
                                    }
                                    {shippingAddress.City &&
                                        <React.Fragment>
                                            {shippingAddress.City} <br />
                                        </React.Fragment>
                                    }
                                    {shippingAddress.State &&
                                        <React.Fragment>
                                            {shippingAddress.State} <br />
                                        </React.Fragment>
                                    }
                                    {shippingAddress.Country}<br />
                                    {shippingAddress.PostCode}<br />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            );
        } else {
            return "";
        }
    }

    renderRecogerSucursal(data) {
        let mapSrc = "https://maps.google.com/maps?width=100%25&height=450&hl=es&q=" + data.Latitud +"," + data.Longitud +"+(Mi%20nombre%20de%20egocios)&t=&z=14&ie=UTF8&iwloc=B&output=embed";        
        return (
            <div className="col-md-4">
                <table className="canon-table purchase-address-sec">
                    <tbody>
                        <tr>
                            <th className="OD-tittle-subsection">Recoger en sucursal:</th>
                        </tr>
                        <tr>
                            <td style={{fontWeight : 'bold'}}>
                                { data.Nombre }
                            </td>
                        </tr>
                        <tr>
                            <td>
                                { data.Direccion }
                            </td>
                        </tr>
                    </tbody>
                </table>
                <iframe width="100%" height="450" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0"
                    src={mapSrc}>
                        <a href="https://www.gps.ie/car-satnav-gps/">Car GPS</a>
                </iframe>
            </div>
        );
    }

    renderBillingAddress() {
        let shippingAddress = null;
        if (this.props.detail.Orders) {
            shippingAddress = this.props.detail.Orders[0].BillingToAddress;
        } else {
            shippingAddress = this.props.detail.BillingToAddress;
        }

        const buyerName = shippingAddress.Name && shippingAddress.Name.split('|').length > 1 ? shippingAddress.Name.replace('|', ' ') : shippingAddress.Name;
        const buyerDisplayName = this.props.user.DisplayName;
        const line2 = shippingAddress.Line2 ? shippingAddress.Line2 : "";

        let email = "";
        let number = "";

        if (this.props.detail.Orders && this.props.detail.Orders[0].ConsumerDetail.Email) {
            email = this.props.detail.Orders[0].ConsumerDetail.Email;
        } else {
            email = this.props.detail.ConsumerDetail.Email;
        }

        if (this.props.detail.Orders && this.props.detail.Orders[0].ConsumerDetail.PhoneNumber) {
            number = this.props.detail.Orders[0].ConsumerDetail.PhoneNumber;
        } else {
            number = this.props.detail.ConsumerDetail.PhoneNumber;
        }

        return (
            <div className="col-md-4">
                <table className="canon-table purchase-address-sec">
                    <tbody><tr>
                        <th className="OD-tittle-subsection">Dirección de facturación:</th>
                    </tr>
                        <tr>
                            <td className="billing-address" data-th="Billing Address :">
                                <span className="highlight-text">{buyerDisplayName}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span className="highlight-text">{buyerName}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {shippingAddress.Line1},<br />
                                {line2 &&
                                    <React.Fragment>
                                        {line2} <br />
                                    </React.Fragment>
                                }
                                {shippingAddress.City &&
                                    <React.Fragment>
                                        {shippingAddress.City} <br />
                                    </React.Fragment>
                                }
                                {shippingAddress.State &&
                                    <React.Fragment>
                                        {shippingAddress.State} <br />
                                    </React.Fragment>
                                }
                                {shippingAddress.Country}<br />
                                {shippingAddress.PostCode}<br />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href={"tel:+" + number}>+{number}</a><span className="text-spacer" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href={"mailto:" + email}>{email}</a>
                            </td>
                        </tr>
                    </tbody></table>
            </div>
        );
    }

    updateDataModalSupplyOrders(dataModal){
        console.log("Cambió modal")
        console.log(dataModal)
        var self = this;

        var classModal = ".modalOrderID-general";
        this.setState({ datamodalSupplyOrder: dataModal });
        $(classModal).modal("show")
        if ($('.modal-backdrop').is(':visible')) {
            $('.modal-backdrop').removeClass('modal-backdrop');
        };
    }

    updateDataModalShippingGuides(dataModal){
        console.log("Cambió modal ShippingGuides")
        console.log(dataModal)

        var classModal = ".modalShippingGuides-general";
        this.setState({ datamodalShippingGuides: dataModal });
        $(classModal).modal("show")
        if ($('.modal-backdrop').is(':visible')) {
            $('.modal-backdrop').removeClass('modal-backdrop');
        };
    }
    
    renderTablesOrders(){
        var self = this;
        if(this.props.detail !== null && this.props.detail !== undefined){
            if(this.props.detail.Orders && this.props.detail.Orders.length > 0 && this.props.detail.Orders[0].CustomFields != null){
         
                var Order = this.props.detail.Orders[0];
                let ordersLiderIds = Order.CustomFields.find(x => x.Name == process.env.LIDER_ORDER_IDS);

                if(ordersLiderIds !== null && ordersLiderIds !== undefined){
                    if(ordersLiderIds.Values.length > 0 && ordersLiderIds.Values[0] !== ""){
                        var arrStrOrdersIDs =  ordersLiderIds.Values[0].split(", ")
                       // var ordersIDs = ["5450955", "5450957", "5450958", "5451052"]
                        return arrStrOrdersIDs.map(function (itemOrder) {
                           {return (
                                <div key={itemOrder} className="row table-orderslider">
                                    <TableInvoicesComponent  
                                        orderdata={self.state.data}
                                        orderId={itemOrder}
                                        user = {self.props.user}
                                        customerRFC = {self.state.customerRFC}
                                        updateDataModalSupplyOrders = {self.updateDataModalSupplyOrders}
                                        updateDataModalShippingGuides = {self.updateDataModalShippingGuides}
                                    />
                                </div>
                            )}
                        });
                    }

                }

                
            }
        }
    }

    renderCommonView() {
        const detail = this.props.detail;
        const order = detail;
        const order2 = detail.Orders[0];
        const cartItem = order2.CartItemDetails[0];
        let notes = '';
        let recogerSucursal = {};
        let IsRecogerSucursal = false;
        if (cartItem.Notes){
            notes = cartItem.Notes;
            if(notes.includes("Recoger en sucursal|")){
                let arrRecogerSucursal = notes.split("|");                
                recogerSucursal.Nombre = arrRecogerSucursal[1];
                recogerSucursal.Direccion = arrRecogerSucursal[2];
                recogerSucursal.Latitud = arrRecogerSucursal[3];
                recogerSucursal.Longitud = arrRecogerSucursal[4];
                IsRecogerSucursal = true;
            }
        }
        //ARC8925
        let dateToUse = order.CreatedDateTime;
        if (order.CreatedDateTime == null) {
            if (order.Orders) {
                dateToUse = order.Orders[0].CreatedDateTime;
            }
        }
        return (
            <div className="main" id="main-subcontent-order-detail" style={{ paddingTop: '46px' }}>
                <div className="orderlist-container">
                    <div className="container-fluid">
                        {/* title */}
                        <div className="sc-upper">
                            <div className="sc-u title-sc-u sc-u-mid full-width">
                                <div className="nav-breadcrumb">
                                    <i className="fa fa-angle-left" /> <a id="regresarPagination" href="/purchase/history">Regresar</a>
                                </div>
                            </div>
                            <div className="flex-title">
                                <span className="sc-text-big">Detalles del pedido {this.props.detail.Orders[0].CosmeticNo != null && order.CosmeticNo != "" ? this.props.detail.Orders[0].CosmeticNo : this.props.detail.Orders[0].PurchaseOrderNo}</span>
                             {/*   <div className="order-date pull-right">{this.formatDateTime(dateToUse)}</div> */}
                            </div>
                        </div>
                        {/* title */}
                        <section className="sassy-box sections-order-detail">
                            <div className="sassy-box-content box-order-detail">
                                <div className="row">
                                    {   IsRecogerSucursal
                                        ? this.renderRecogerSucursal(recogerSucursal)
                                        : this.renderShippingAddress()
                                    }
                                    {this.renderBillingAddress()}
                                    <div className="col-md-4" />
                                      {  <ShippingPaymentDetailComponent {...this.props} />  }
                                    <div className="spacer-20" />
                                    {/*<div className="col-md-12">
                                        <div className="row">
                                            {this.renderSupplierAddress()}
                                            {this.renderShippingAddress()}
                                        </div>
                                    </div>*/}
                                </div>
                              {  <TransactionSummaryComponent {...this.props} checkoutFlowType={process.env.CHECKOUT_FLOW_TYPE} showNotes={process.env.PRICING_TYPE == 'service_level'} />}
                             {/*   <SummaryOrder {...this.props} orderdata={this.state.data}/>*/}
                            </div>
                        </section>
                        <section className="sassy-box sections-order-detail">
                            <div className="sassy-box-content box-order-detail-invoices">
                                <div className="row">
                                   {/* <TableInvoicesComponent orderdata={this.state.data} orderId={this.state.data.OrderID} user = {this.props.user}/>*/}
                                    {this.renderTablesOrders()}
                                    <OrderItemsTableComponent datatable={this.state.datamodalSupplyOrder} dataestafeta={this.state.datamodalShippingGuides} />
                                </div>
                            </div>
                        </section>
                        
                        <TableContentComponent {...this.props} />
                        {/*<TransactionSummaryComponent {...this.props} checkoutFlowType={process.env.CHECKOUT_FLOW_TYPE} showNotes={process.env.PRICING_TYPE == 'service_level'} />*/}
                        <OrderDiaryComponent
                            eventCustomField={this.props.eventCustomField}
                            events={this.getAllEvents()}
                            selectedSection={this.props.selectedSection}
                            selectedTabSection={this.props.selectedTabSection}
                            uploadFile={this.props.uploadFile}
                            isValidUpload={this.props.isValidUpload}
                            isSuccessCreate={this.props.isSuccessCreate}
                            fetchEvents={this.props.fetchEvents}
                            updateSelectedSection={this.props.updateSelectedSection}
                            updateSelectedTabSection={this.props.updateSelectedTabSection}
                            setUploadFile={this.props.setUploadFile}
                            createEvent={this.props.createEvent} />
                    </div>
                </div>
            </div>
        );
    }

    renderFeedBackPopUp() {
        return (
            <div className="popup-area order-item-feedback-popup" style={{ display: 'none' }}>
                <div className="wrapper">
                    <div className="title-area text-capitalize">
                        <div className="pull-left">LEAVE A FEEDBACK FOR:</div>
                        <div className="pull-right">
                            <a href={'#'} className="close-popup-icon">
                                <img src="/assets/images/icon-cross-black.png" />
                            </a>
                        </div>
                        <div className="clearfix" />
                    </div>
                    <div className="content-area">
                        <div className="ordr-dtls-item-itemdesc">
                            <div className="ordr-dtls-item-iteminfo">
                                <div className="item-img">
                                    <a href={null}>
                                        <span><img src={null} className="item-preview" /></span>
                                    </a>
                                </div>
                                <div className="item-info-text">
                                    <div>
                                        <a href={null} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p>&nbsp;</p>
                        <p>How much do you rate this item?</p>
                        <input type="hidden" value="" name="rating_val" />
                        <div id="stars" className="starrr">
                        </div>
                        <br />
                        <p>
                            <textarea name="feedbackText" className="form-controler" placeholder="Leave a feedback..." />
                        </p>
                    </div>
                    <div className="btn-area text-center">
                        <input type="button" value="SUBMIT" className="my-btn btn-red-popup" />
                        <div className="clearfix" />
                    </div>
                </div>
            </div>
        );
    }

    submitFeedback(rating, feedback) {
        const self = this;
        const { selectedCartItemID } = this.state;
        if (selectedCartItemID && rating !== '') {
            this.props.submitFeedbackForCartItem({ InvoiceNo: this.props.InvoiceNo, cartId: selectedCartItemID, rating, feedback }, function (result) {
                if (result.success === true) {
                    toastr.success(result.message, '');
                }
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="header mod" id="header-section">
                    <HeaderLayoutComponent categories={this.props.categories} user={this.props.user} />
                </div>
                {/*<aside className="sidebar" id="sidebar-section">
                    <SidebarLayoutComponent user={this.props.user} />
                </aside>*/}
                <div className="main-content" id="main-content-order-detail">
                    {this.renderCommonView()}
                </div>
                {this.renderFeedBackPopUp()}
                <div className="footer footer-order-detail" id="footer-section">
                    <FooterLayout panels={this.props.panels} />
                </div>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        user: state.userReducer.user,
        detail: state.purchaseReducer.detail,
        shippingMethod: state.purchaseReducer.shippingMethod,
        enableReviewAndRating: state.purchaseReducer.enableReviewAndRating,
        locationVariantGroupId: state.marketplaceReducer.locationVariantGroupId,
        // Order Diary
        eventCustomField: state.orderDiaryReducer.eventCustomField,
        events: state.orderDiaryReducer.events,
        otherEvents: state.orderDiaryReducer.otherEvents,
        selectedSection: state.orderDiaryReducer.selectedSection,
        selectedTabSection: state.orderDiaryReducer.selectedTabSection,
        uploadFile: state.orderDiaryReducer.uploadFile,
        isValidUpload: state.orderDiaryReducer.isValidUpload,
        isSuccessCreate: state.orderDiaryReducer.isSuccessCreate
    }
}

function mapDispatchToProps(dispatch) {
    return {
        submitFeedbackForCartItem: (options, callback) => dispatch(submitFeedbackForCartItem(options, callback)),
        // Order Diary
        fetchEvents: () => dispatch(OrderDiaryActions.fetchEvents()),
        updateSelectedSection: (section) => dispatch(OrderDiaryActions.updateSelectedSection(section)),
        updateSelectedTabSection: (section) => dispatch(OrderDiaryActions.updateSelectedTabSection(section)),
        setUploadFile: (file, isValid) => dispatch(OrderDiaryActions.setUploadFile(file, isValid)),
        createEvent: (event, formData) => dispatch(OrderDiaryActions.createEvent(event, formData))
    };
}

const PurchaseDetailHome = ReactRedux.connect(
    mapStateToProps,
    mapDispatchToProps
)(PurchaseDetailComponent);

module.exports = {
    PurchaseDetailHome,
    PurchaseDetailComponent,
};